import { useEffect, useState } from "react";

import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

const useMapExtentFilter = ({ view, setFilterGeometry }) => {
  const state = useState(false);
  const [isFilterMapExtentActive, _setFilterMapExtentActive] = state;
  useEffect(() => {
    let handler;
    if (!view) return;

    if (isFilterMapExtentActive) {
      handler = reactiveUtils.when(
        () => !!view?.stationary,
        (stationary) => {
          if (!isFilterMapExtentActive) return;

          if (setFilterGeometry) {
            setFilterGeometry(view.extent);
          }
        },
        { initial: true }
      );
    }
    return () => {
      handler?.remove();
      setFilterGeometry(null);
    };
  }, [isFilterMapExtentActive]);

  return state;
};

export default useMapExtentFilter;
